import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { useWidgetSeo } from '../widget-hooks/use-widget-seo';
import { TrainerManageSlotsSection } from './trainer_TrainerManageSlotsSection';

export default function TrainerMySessionsPage() {
  useWidgetSeo(
    'Мои тренировки | Кабинет тренера',
    'Список предстоящих тренировок и проведенных занятий.'
  );
  const { widgetContour, hasPermission } = useEmbedBootstrap();
  const trainerMobileLayout = widgetContour === 'trainer-mobile' ? ('today' as const) : null;
  const canStaffScheduleWrite = hasPermission('schedule:staff_write');
  return (
    <TrainerManageSlotsSection
      heading="Мои тренировки"
      description="Занятия на сегодня: кто записан, отметка прихода и связь с клиентом."
      trainerMobileLayout={trainerMobileLayout}
      canStaffScheduleWrite={canStaffScheduleWrite}
    />
  );
}
